const launchSuccessOverlay = (textMarkup = '', linkMarkup = '', animation = '') => {
    const overlay = document.querySelector("#success-overlay");
    try {
        document.querySelector("#error-overlay").classList.add('hide');
    } catch {}


    
    if (overlay.classList.contains('hide')) {
        document.querySelector('#success-overlay .success-overlay-text').innerHTML = textMarkup;
        document.querySelector('#success-overlay .success-overlay-link').innerHTML = linkMarkup;
        document.querySelector('#success-overlay .success-overlay-text').focus();
        overlay.classList.remove('hide');
        try {
            const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

            if (animation !== '') {
                if (!isReduced) {
                    document.querySelector('.robo-rect').style.display = 'flex'
                }
            } else {
                document.querySelector('.robo-rect').style.display = 'none'
            }
        } catch {}
        setTimeout(() => { 
            overlay.classList.add('hide');
        }, 5000);
    } else {
        overlay.classList.add('hide');
        setTimeout(() => {
            document.querySelector('#success-overlay .success-overlay-text').innerHTML = textMarkup;
            document.querySelector('#success-overlay .success-overlay-link').innerHTML = linkMarkup;
            document.querySelector('#success-overlay .success-overlay-text').focus();
            overlay.classList.remove('hide');
            try {
                const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
                if (animation !== '') {
                    if (!isReduced) {
                        document.querySelector('.robo-rect').style.display = 'flex'
                    }
                } else {
                    document.querySelector('.robo-rect').style.display = 'none'
                }
            } catch {}
            setTimeout(() => { 
                overlay.classList.add('hide');
            }, 5000);
        }, 50);
    }
}

export default launchSuccessOverlay;